
export const isfieldMissing = ({columns,formData}) => {    
    const missing = columns.some((item) => {
      const value = formData[item?.name];
      return item.required && !value;
    });
    return missing;
  };